export const clipboardMixin = {
	methods: {
		async copyToClipboard(text) {
			try {
				await navigator.clipboard.writeText(text);
			} catch (err) {
				console.error('Failed to copy text: ', err);
			}
		}
	}
};
